import { watch } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user.stores'
import { useAuth } from '@/composables/useAuth'
import { useBaseConfirmModal } from '@/components/Base/modal/useBaseConfirmModal'

/**
 * 登入後若密碼已超過 180 天未更換（OP#2664），強制彈出提示：變更密碼（導去個人
 * 資訊頁）或沿用舊密碼（直接打變更密碼 API 給空字串）。
 * @remarks `useBaseConfirmModal` 的 `maskClosable`/`closable` 皆為 false，使用者
 *          必須二擇一才能關閉，不能透過點擊遮罩或叉叉忽略這個安全性提醒。
 */
export const usePasswordExpiryPrompt = createGlobalState(() => {
  const userStore = useUserStore()
  const router = useRouter()
  const { t } = useI18n()
  const { fnKeepCurrentPassword } = useAuth()
  const { openConfirm } = useBaseConfirmModal()

  watch(
    () => userStore.isPwdNotChangeOver180Days,
    (shouldPrompt) => {
      if (!shouldPrompt) return

      openConfirm({
        title: t('LoginPage.Modal.PasswordExpiry.Title'),
        content: t('LoginPage.Modal.PasswordExpiry.Content'),
        okText: t('LoginPage.Modal.PasswordExpiry.Button.Change'),
        cancelText: t('LoginPage.Modal.PasswordExpiry.Button.KeepCurrent'),
        onOk: () => {
          userStore.isPwdNotChangeOver180Days = false
          // query 帶 action=change-password，PasswordModal 會自動開啟修改密碼視窗
          router.push({ name: 'Profile', query: { action: 'change-password' } })
        },
        onCancel: () => {
          fnKeepCurrentPassword()
        }
      })
    }
  )
})
